<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" class="main-column">
        <v-img
          class="mt-15"
          src="../assets/logo.svg"
          max-height="2.5em"
          contain
        />
        <v-container class="mt-10" fluid>
          <v-form v-model="valid" ref="form">
            <LoginError
              v-model="showError"
              :message="errorMessage"
            />
            <v-row justify="center" class="mb-10">
              <v-avatar color="#C4C4C4" size="100" @click="launchFilePicker()">
                <v-icon v-if="!avatarURL">mdi-plus</v-icon>
                <v-img v-else :src="avatarURL"/>
                <input
                  type="file"
                  ref="file"
                  accept=".jpg,.jpeg,.png"
                  :name="avatarImageName"
                  @change="onFileChange($event.target.files)"
                  style="display:none">
              </v-avatar>
            </v-row>
            <v-text-field
              class="mt-2"
              label="Nome"
              v-model="name"
              :rules="nameRules"
              outlined
              rounded
              dense
              validate-on-blur
              required
            />
            <v-text-field
              class="mt-2"
              label="Email"
              v-model="email"
              :rules="emailRules"
              outlined
              rounded
              dense
              validate-on-blur
              required
            />
            <v-text-field
              class="mt-2"
              :type="showPassword ? 'text' : 'password'"
              label="Senha"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="signUp"
              v-model="password"
              :rules="passwordRules"
              outlined
              rounded
              dense
              validate-on-blur
              required
            />
          </v-form>
          <v-row justify="center" class="mt-5">
            <v-btn
              @click="signUp"
              color="#CE3E17"
              dark
              rounded
              depressed
              style="font-weight: lighter"
              :loading="loading"
            >Confirmar</v-btn>
          </v-row>
          <v-row justify="center" class="mt-5">
            <p>Já possui uma conta? <a style="color: #CE3E17"  @click="signIn()">Login</a></p>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { auth } from "@/firebase";
import LoginError from "@/components/LoginError.vue";

export default {
  name: "SignUp",
  beforeRouteEnter(to, from, next) {
    if (auth.currentUser) next({ name: "Profile" });
    else next();
  },
  components: {
    LoginError
  },
  data() {
    return {
      showPassword: false,
      avatarImage: undefined,
      avatarURL: "",
      avatarImageName: "",
      name: "",
      email: "",
      password: "",
      loading: false,
      error: "",
      errorMessage: "",
      showError: false,
      valid: false,
      imageRules: [
        v => !v || v.size < 2000000 || "O tamanho da imagem deve ser menor que 2MB"
      ],
      nameRules: [
        v => !!v || "Nome é necessário."
      ],
      emailRules: [
        v => !!v || "Email é necessário.",
        v => /.+@.+/.test(v) || "Email precisa ser válido."
      ],
      passwordRules: [
        v => !!v || "Senha é necessária.",
        v => v.length >= 5 || "Senha conter ao menos 5 caracteres.",
        v =>
          /.*[!@#$%^&*(),.?":{}|<>].*/.test(v) ||
          "A senha precisa conter ao menos um caracter especial.",
        v =>
          /.*[0-9].*/.test(v) ||
          "A senha deve conter ao menos um caracter numérico."
      ]
    };
  },
  computed: {
    ...mapState([
      "storage"
    ]),
    ...mapGetters([
      "loggedIn"
    ])
  },
  methods: {
    displayError(message) {
      this.showError = true;
      this.errorMessage = message;
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    onFileChange(files) {
      this.avatarImage = files[0];
      this.avatarURL = URL.createObjectURL(this.avatarImage);
    },
    signIn() { this.$router.push({ name: "Login" }); },
    signUp() {
      this.$refs.form.validate();
      if (this.valid && !this.loggedIn) {
        this.loading = true;
        this.$store.dispatch("create_user", {
          name: this.name,
          email: this.email,
          password: this.password,
          avatarImage: this.avatarImage
        }).then(() => {
            if (this.$route.query.redirect) this.$router.replace(this.$route.quer.redirect);
            else this.$router.go(-1);
          })
          .catch(err => {
            console.error(err.message);
            switch (err.code) {
              case "auth/email-already-in-use":
                this.error = "email-already-in-use";
                this.displayError("Esse email já está sendo utilizado.");
                break;

              case "auth/invalid-email":
                this.error = "invalid-email";
                this.displayError("Esse email é inválido.");
                break;

              case "auth/operation-not-allowed":
                this.error = "operation-not-allowed";
                this.displayError("Operação não permitida.");
                break;

              case "auth/weak-password":
                this.error = "week-password";
                this.displayError("Senha muito fraca.");
                break;

              default:
                this.error = "unknown";
                this.displayError("Ocorreu um erro inesperado. Tente novamente mais tarde.");
            }
          })
          .finally(() => {
            this.name = "";
            this.email = "";
            this.password = "";
            this.showPassword = false;
            this.loading = false;
          });
      }
    }
  }
};
</script>
<style lang="scss">
.login-subheader {
  color: #CE3E17 !important;
  font-size: 1.2em !important;
  height: auto;
}
</style>